import { render, staticRenderFns } from "./CourseFlags.vue?vue&type=template&id=78d01cf5&scoped=true"
import script from "./CourseFlags.vue?vue&type=script&lang=js"
export * from "./CourseFlags.vue?vue&type=script&lang=js"
import style0 from "./CourseFlags.vue?vue&type=style&index=0&id=78d01cf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d01cf5",
  null
  
)

export default component.exports